import { apiSetupPromise } from "../AuthenticationProvider/APIAuthSetup";
import { ContextualError } from "@lib/utils/ContextualError";
import { useEffect, useState } from "react";

/**
 * Custom hook to check if the API setup is complete.
 * This is needed to ensure that the API client is ready before rendering components
 * that depend on it.
 */
export const useAPISetupStatus = () => {
  const [isSetupComplete, setIsSetupComplete] = useState(false);

  useEffect(() => {
    const checkSetup = async () => {
      try {
        await apiSetupPromise;
        setIsSetupComplete(true);
      } catch (error) {
        throw new ContextualError("API setup failed", {
          cause: error instanceof Error ? error.message : error
        });
      }
    };

    void checkSetup();
  }, []);

  return isSetupComplete;
};
